import { render, staticRenderFns } from "./LoginFailure.vue?vue&type=template&id=7a1a128d&"
import script from "./LoginFailure.vue?vue&type=script&lang=js&"
export * from "./LoginFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports